export default[
    {
        path: '/ver/pagamento/:folhar_id/:trabalhador_id',
        name: 'ver o pagamento', 
        component: () => import(/* webpackChunkName: "Login" */ './page/index.vue')
    },
    // {
    //     path: '/folhar/lista',
    //     name: 'lista', 
    //     component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    // },
    // {
    //     path: '/folhar/editar/:id',
    //     name: 'lista', 
    //     component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    // },
]